
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { AuthPaymentProvider } from "./contexts/AuthPaymentContext";
import { DisableHooksProvider } from "./contexts/DisableHooksContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import AppRoutes from "./components/routing/AppRoutes";

const queryClient = new QueryClient();

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TooltipProvider>
            <AuthProvider>
              <AuthPaymentProvider>
                <DisableHooksProvider>
                  <AppRoutes />
                  <Toaster />
                </DisableHooksProvider>
              </AuthPaymentProvider>
            </AuthProvider>
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
